import { useEffect, useRef, useState } from "react";
import { io } from "socket.io-client";

// One shared Socket.IO connection for the whole CRM. Engine.IO endpoint is /api/socketio
// (under the /api ingress). Polling always works; websocket upgrades when the proxy allows.
let _socket = null;
function getSocket() {
  if (!_socket) {
    _socket = io(process.env.REACT_APP_BACKEND_URL, {
      path: "/api/socketio",
      transports: ["polling", "websocket"],
      reconnection: true,
      reconnectionDelay: 1000,
    });
  }
  return _socket;
}

// Subscribe to a server event; returns { connected } for the "reconnecting" banner.
export function useCrmSocket(event, handler) {
  const [connected, setConnected] = useState(false);
  const hRef = useRef(handler);
  hRef.current = handler;
  useEffect(() => {
    const s = getSocket();
    setConnected(s.connected);
    const onConn = () => setConnected(true);
    const onDisc = () => setConnected(false);
    const onEvt = (data) => hRef.current && hRef.current(data);
    s.on("connect", onConn);
    s.on("disconnect", onDisc);
    if (event) s.on(event, onEvt);
    return () => {
      s.off("connect", onConn);
      s.off("disconnect", onDisc);
      if (event) s.off(event, onEvt);
    };
  }, [event]);
  return { connected };
}
